var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length)?_c('div',{staticClass:"fuid-errorfromserver"},_vm._l((_vm.errors),function(error,index){return _c('errorPill',{key:index,attrs:{"message":error.message}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }